export * from './function.any';
/**
 * Returns the visibility state of the gifs menu.
 *
 * @param {IReduxState} state - The state of the application.
 * @returns {boolean}
 */
export function isGifsMenuOpen(state) {
    return state['features/gifs'].menuOpen;
}
